import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { PdfProvider } from '../context/PdfContext';
import FileUpload from '../components/FileUpload/FileUpload';
import FileList from '../components/FileList/FileList';
import PdfViewer from '../components/PdfViewer/PdfViewer';
import TextOutput from '../components/TextOutput/TextOutput';
import DownloadButton from '../components/DownloadButton/DownloadButton';
import AffiliateRecommendations from '../components/Affiliate/AffiliateRecommendations';
import PdfToolsPanel from '../components/PdfTools/PdfToolsPanel';
import PdfImageExportPanel from '../components/PdfTools/PdfImageExportPanel';
import HomeExtras from '../components/Home/HomeExtras';

const HomePage: React.FC = () => {
  return (
    <PdfProvider>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1" sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }} gutterBottom>
            PDF, Word &amp; Excel to Text &amp; Markdown Converter
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Free and private: files are converted right in your browser and never uploaded.
          </Typography>
        </Box>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
            <Box sx={{ width: { xs: '100%', md: '30%' }, display: 'flex', flexDirection: 'column' }}>
              <FileUpload />
              <Box sx={{ mt: 2 }}>
                <FileList />
              </Box>
              <AffiliateRecommendations />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '70%' } }}>
              <PdfViewer />
              <Box sx={{ mt: 3 }}>
                <TextOutput />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                  <DownloadButton />
                </Box>
                <PdfToolsPanel />
                <PdfImageExportPanel />
              </Box>
            </Box>
          </Stack>
        </Stack>
        <HomeExtras />
      </Box>
    </PdfProvider>
  );
};

export default HomePage;
